export const MERCHANT_PRODUCTS = [
  "CULQIFULL",
  "CULQILINK",
  "CULQIONLINE",
] as const;

export const GPV_MAX_MONTH_OFFSET = 3;

export const COHORT_OFFSETS: readonly number[] = Array.from(
  { length: GPV_MAX_MONTH_OFFSET + 1 },
  (_, offset) => offset,
);

const ATTRIBUTION_METHODS = ["crm_owner", "manual", "none"] as const;
export type AttributionMethod = (typeof ATTRIBUTION_METHODS)[number];

const ATTRIBUTION_CONFIDENCES = ["exact", "none"] as const;
export type AttributionConfidence = (typeof ATTRIBUTION_CONFIDENCES)[number];

export const QUALITY_ISSUES = [
  "no_owner",
  "no_target",
  "serial_mismatch",
  "no_mesa",
] as const;
export type QualityIssue = (typeof QUALITY_ISSUES)[number];

export function isQualityIssue(value: string): value is QualityIssue {
  return QUALITY_ISSUES.some((issue) => issue === value);
}

export const DORMANT_AFTER_DAYS = 30;
